import { createContext, type Context } from 'react';

import type { TownsquareApp } from '../types';

type UserProfileCardContextValues = {
	cloudId: string;
	townsquareApp?: TownsquareApp;
	onProfileClick?: (userId: string) => void;
	getTestId: (suffix: string) => string | undefined;
	/** True when a real `UserProfileCardContext.Provider` is in the tree. */
	isProvided?: boolean;
};

const UserProfileCardContext: Context<UserProfileCardContextValues> =
	createContext<UserProfileCardContextValues>({
		cloudId: '',
		townsquareApp: undefined,
		onProfileClick: undefined,
		getTestId: () => undefined,
		isProvided: false,
	});

export { UserProfileCardContext };
export type { UserProfileCardContextValues };
